/*
 * Copyright © HatioLab Inc. All rights reserved.
 */

import { Popup, sceneComponent } from '@hatiolab/things-scene'

@sceneComponent('popup')
export default class ClickablePopup extends Popup {
  onclick() {
    this.value = {
      ...this.value,
      timestamp: Date.now()
    }
  }
}
